import getBlockTemplateById from './block-template-by-id';
import getBlockTemplates from './block-templates';
import getUsedBlockTemplatesIds from './used-block-templates-ids';

export default {
  getBlockTemplateById,
  getBlockTemplates,
  getUsedBlockTemplatesIds,
};
